import type { ReactNode } from "react";
import type { FrontGuideStep } from "lib/frontPageData";
import GuideStepRow from "./GuideStepRow";

type GuidePanelProps = {
  heading: string;
  steps: FrontGuideStep[];
  gifSrc?: string;
  gifAlt?: string;
  footer?: ReactNode;
};

export default function GuidePanel({
  heading,
  steps,
  gifSrc,
  gifAlt = "Tutorial",
  footer,
}: GuidePanelProps) {
  return (
    <div
      className={`grid grid-cols-1 items-center gap-12 rounded-2xl border border-[var(--dash-border)] bg-[var(--dash-surface)] p-6 shadow-2xl md:p-10 ${
        gifSrc ? "lg:grid-cols-2" : ""
      }`}
    >
      <div className={`space-y-8 ${gifSrc ? "order-2 lg:order-1" : ""}`}>
        <h2 className="text-2xl font-bold tracking-tight text-[var(--dash-text-strong)] md:text-4xl">
          {heading}
        </h2>
        <div className="space-y-6">
          {steps.map((step, i) => (
            <GuideStepRow key={step.title} index={i + 1} title={step.title} body={step.body} />
          ))}
        </div>
        {footer}
      </div>
      {gifSrc ? (
        <div className="order-1 flex aspect-video items-center justify-center overflow-hidden rounded-2xl border border-[var(--dash-border)] bg-black lg:order-2">
          <img src={gifSrc} alt={gifAlt} className="h-full w-full object-cover" />
        </div>
      ) : null}
    </div>
  );
}
